import { createSelector } from '@reduxjs/toolkit'

export const makeFolderSelectorIsSearching = () => createSelector(
  (state) => state.folders,
  (slice) => {
    const { isSearching } = slice
    return isSearching
  }
)

export const makeFolderSelectorSearchResults = () => createSelector(
  (state) => state.folders,
  (slice) => {
    const { searchResults } = slice
    return searchResults
  }
)
